export default __webpack_public_path__ + "static/media/up2x~YSvshysi.dd574fd1.jpg";